import { Component } from '@angular/core';

@Component({
  selector: 'app-price-parametros',
  templateUrl: './price-parametros.component.html',
  styleUrls: ['./price-parametros.component.scss']
})
export class PriceParametrosComponent {

}
